module.exports = __webpack_public_path__ + "img/240779377_4275395475874472_1147969954718171706_n-320x400.a07b6218.jpg";